import { render } from "./BettingSaved.vue?vue&type=template&id=4add597c"
import script from "./BettingSaved.vue?vue&type=script&lang=js"
export * from "./BettingSaved.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__